import React from 'react'
import './nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {SlNotebook} from 'react-icons/sl'
import {RiServiceLine} from 'react-icons/ri'
import {AiOutlineMessage} from 'react-icons/ai'
import { useState } from 'react' /* Use State Hooks */

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#') 
/* Use State Hooks */
  return (
    <nav>
      <a href="#" onClick={() => setActiveNav('#')} className={activeNav  === '#' ? 'active': ''}><AiOutlineHome/></a>
      <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav  === '#about' ? 'active': ''}><AiOutlineUser/></a>
      <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav  === '#experience' ? 'active': ''}><SlNotebook/></a>
      <a href="#services" onClick={() => setActiveNav('#services')} className={activeNav  === '#services' ? 'active': ''}><RiServiceLine/></a>
      <a href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav  === '#contact' ? 'active': ''}><AiOutlineMessage/></a>
    </nav>
  )
}

export default Nav
